const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-follow-tags', 'forum/utils/getDefaultFollowingFiltering');